import React from "react";

import Heading from "@common/components/Heading/Heading";
import { TicketStatus } from "@common/models/TicketStatus.model";
import { vars } from "@common/styles";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import { quantity } from "@common/util/strings";
import { TicketListFilters } from "@main/pages/Release/helpers/ticketListLink";
import { ReleaseMetricCard, ReleaseMetricCardBaseProps } from "@main/pages/Release/views/MetricCards/ReleaseMetricCard";
import { OpenExternalButton } from "@main/pages/Release/views/MetricCards/shared/OpenExternalButton";
import * as Icon from "@main/pages/shared/icons/icons";

interface CrashesVolumeCardProps extends ReleaseMetricCardBaseProps {
  totalCrashes: number;
  closedCrashes: number;
  totalCrashEvents: number;
  onOpenCrashGroups: (filters: TicketListFilters) => void;
}

const CrashesVolumeCard = ({
  style,
  totalCrashes,
  closedCrashes,
  totalCrashEvents,
  score,
  highlight,
  error,
  onMoreClick,
  onOpenCrashGroups,
}: CrashesVolumeCardProps) => {
  return (
    <ReleaseMetricCard
      style={style}
      title={"Crashes volume"}
      score={score}
      highlight={highlight}
      error={error}
      onMoreClick={onMoreClick}
    >
      <Flex $column>
        <Flex style={{ alignItems: "center" }}>
          <Heading
            heading2
            marginBottom={0}
          >{`${totalCrashes.toString()} ${quantity(totalCrashes, "group", "groups")}`}</Heading>
          <OpenExternalButton
            style={{ marginLeft: "0.4rem", marginRight: "1.8rem" }}
            onClick={() => onOpenCrashGroups({})}
          />
          <Icon.StatusDoneIcon />
          <Heading
            heading2
            style={{ marginLeft: "0.6rem", marginBottom: 0, color: vars.colors.greenDarken }}
            marginBottom={0}
          >
            {closedCrashes.toString() + " closed"}
          </Heading>
          <OpenExternalButton
            style={{ marginLeft: "0.4rem" }}
            onClick={() => onOpenCrashGroups({ status: TicketStatus.CLOSED })}
          />
        </Flex>

        <Heading
          heading3
          style={{ color: vars.colors.grey60 }}
          marginBottom={0}
        >{`${totalCrashEvents.toString()} ${quantity(totalCrashEvents, "crash event", "crash events")}`}</Heading>
      </Flex>
    </ReleaseMetricCard>
  );
};

export { CrashesVolumeCard };
